import type { ReactElement } from "react"
import type { Control, FieldPath, FieldValues } from "react-hook-form"
import { useController } from "react-hook-form"

import type { AerosCheckboxProps } from "../AerosCheckbox"
import { AerosCheckbox } from "../AerosCheckbox"

interface FormCheckboxProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends Omit<AerosCheckboxProps, "name" | "defaultValue" | "onChange"> {
  control: Control<TFieldValues>
  name: TName
  onChange?: (value: boolean) => void
}

export const FormCheckbox = <TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  onChange,
  ...props
}: FormCheckboxProps<TFieldValues, TName>): ReactElement => {
  const { field } = useController({
    name,
    control,
  })

  const handleChange = (checked: boolean) => {
    field.onChange(checked)
    onChange?.(checked)
  }

  return <AerosCheckbox {...field} {...props} checked={field.value} onChange={handleChange} />
}
